import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addDays, format, subDays } from 'date-fns';


import List, { ListItem } from './List';
import { getBigNumbers, getPeriodList } from '../../../../redux/dashboard-completed';
import { getDeliveryStatusDeliveriesList } from '../../../../redux/delivery-status';
import { changeFilters } from '../../../../redux/dashboard-filters';
import { getNfListLocation } from '../../../../redux/dashboard-real-time';

import CustomerModal from './CustomerModal';
import ShippingCompanyModal from './ShippingCompanyModal';
import ShippingGroupModal from './ShippingGroupModal';
import RegionModal from './RegionModal';
import ManifestModal, { manifestFilters } from './ManifestModal';
import Panel from '../Panel';
import RetrofitDateModal, { dateFilterToDays, DATE_FILTERS, periodFilterToDays } from './RetrofitDateModal';
import { Edit } from '@mui/icons-material';

class DashboardFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialDate: format(
        subDays(new Date(), periodFilterToDays.LAST_30_DAYS),
        'yyyy-MM-dd',
      ),
      finalDate: format(new Date(), 'yyyy-MM-dd'),
      byDate: 1,
      dateModalVisible: false,
      customerModalVisible: false,
      shippingCompanyModalVisible: false,
      regionModalVisible: false,
      manifestModalVisible: false,
    };
  }

  componentDidMount() {
    const { initialPeriod, finalPeriod } = this.props;
    this.props.dispatch(changeFilters({ initialPeriod, finalPeriod }));
  }

  _toggleFilterModal = (modalProp, shouldApplyFilter = false) => {
    this.setState({
      [modalProp]: !this.state[modalProp],
    });

    if (shouldApplyFilter) {
      const { applyOnHistory, applyOnDeliveryStatus } = this.props;

      if (applyOnHistory) {
        this._getBigNumbers();
        this._getPeriodList();
      }

      if (applyOnDeliveryStatus) {
        this._getDeliveryStatus();
      }
    }
  }

  _getBigNumbers = () => {
    this.props.dispatch(getBigNumbers());
  }

  _getPeriodList = () => {
    this.props.dispatch(getPeriodList());
  }

  _getDeliveryStatus = () => {
    this.props.dispatch(getDeliveryStatusDeliveriesList(false, 'realTime', this.props.notPassCompanyId)).then(data => this.props.dispatch(getNfListLocation(this.props.deliveryStatusActiveTab, data)));
  }

  // date

  _getDateFilterLabel = () => {
    const { initialPeriod, finalPeriod } = this.props;

    return `${format(addDays(new Date(initialPeriod), 1), 'dd/MM/yyyy')} a ${format(addDays(new Date(finalPeriod), 1), 'dd/MM/yyyy')}`;
  }

  _applyDateFilter = ({ byDate, initialPeriod, finalPeriod }) => {
    this.setState({
      byDate,
      initialDate: initialPeriod,
      finalDate: finalPeriod,
    });
    this.props.dispatch(changeFilters({ byDate, initialPeriod, finalPeriod }));
    this._toggleFilterModal('dateModalVisible', true);
  }

  // customer

  _getCustomerFilterLabel = () => {
    const { selectedCustomers, isOnlyKeyAccounts } = this.props;

    if (isOnlyKeyAccounts) {
      return 'Apenas key accounts';
    }

    if (selectedCustomers.length === 0) {
      return 'Todos os clientes';
    }

    return selectedCustomers.length > 1 ?
      `${selectedCustomers.length} clientes selecionados` :
      '1 cliente selecionado';
  }

  _applyCustomerFilter = (listCustomers, keyAccount = '') => {
    this.props.dispatch(changeFilters({ listCustomers, keyAccount }));
    this._toggleFilterModal('customerModalVisible', true);
  }

  // shipping company

  _getShippingCompanyFilterLabel = () => {
    const { selectedShippingCompanies } = this.props;

    if (selectedShippingCompanies.length === 0) {
      return 'Todas as transportadoras';
    }

    return selectedShippingCompanies.length > 1 ?
      `${selectedShippingCompanies.length} transportadoras selecionadas` :
      '1 transportadora selecionada';
  }

  _applyShippingCompanyFilter = (listCompany) => {
    this.props.dispatch(changeFilters({ listCompany }));
    this._toggleFilterModal('shippingCompanyModalVisible', true);
  }

  // shipping group

  _getShippingGroupFilterLabel = () => {
    const {
      shippingGroupId,
      shippingGroupsList,
    } = this.props;

    if (!shippingGroupId) {
      return 'Todos os grupos';
    }

    const shippingGroupName = shippingGroupsList.filter(shippingGroup => shippingGroup.id === shippingGroupId)[0].nome;

    return `Grupo ${shippingGroupName}`;
  }

  _applyShippingGroupFilter = (selectedOption) => {
    this.props.dispatch(changeFilters({ shippingGroupId: selectedOption.value }));
    this._toggleFilterModal('shippingGroupModalVisible', true);
  }

  // region

  _getRegionFilterLabel = () => {
    const { selectedRegions, selectedUfs } = this.props;

    if (selectedRegions.length === 0 && selectedUfs.length === 0) {
      return 'Todas as regiões';
    }

    if (selectedRegions.length > 0) {
      return selectedRegions.length > 1 ?
        `${selectedRegions.length} regiões selecionadas` :
        '1 região selecionada';
    }

    return selectedUfs.length > 1 ?
      `${selectedUfs.length} estados selecionados` :
      '1 estado selecionado';
  }

  _applyRegionFilter = (listRegion, listUf) => {
    this.props.dispatch(changeFilters({ listRegion, listUf }));
    this._toggleFilterModal('regionModalVisible', true);
  }

  // manifest

  _getManifestFilterLabel = () => {
    const { manifestType } = this.props;

    if (manifestType === manifestFilters.DELIVERY_ONLY) {
      return 'Somente entregas';
    }

    if (manifestType === manifestFilters.TRANSFER_ONLY) {
      return 'Somente transferências';
    }

    return 'Entregas e transferências';
  }

  _applyManifestFilter = (manifestType) => {
    this.props.dispatch(changeFilters({ manifestType }));
    this._toggleFilterModal('manifestModalVisible', true);
  }

  // render

  render() {
    const {
      initialPeriod,
      finalPeriod,
      byDate,
      selectedCustomers,
      isOnlyKeyAccounts,
      selectedShippingCompanies,
      selectedRegions,
      selectedUfs,
      manifestType,
      customerMinimumDigits,
      shippingGroupFilter,
      shippingGroupId,
      customerFilter,
      collapsible,
    } = this.props;
    const {
      dateModalVisible,
      customerModalVisible,
      shippingCompanyModalVisible,
      regionModalVisible,
      manifestModalVisible,
      shippingGroupModalVisible,
    } = this.state;

    const byDateLabel = Number(byDate) === dateFilterToDays.BY_ISSUE_DATE ? 
      DATE_FILTERS.BY_ISSUE_DATE : 
      DATE_FILTERS.BY_DELIVERY_DATE;

    return (
      <Panel 
        collapsible={collapsible} 
        rightIcon={() => {
          return !customerFilter && !shippingGroupFilter && 
            <Edit sx={{cursor: 'pointer'}} onClick={() => { this._toggleFilterModal('dateModalVisible')}} fontSize="small" htmlColor="#fff" />
        }}
        title="Filtros"
      >
        <List>
          <ListItem onClick={() => { this._toggleFilterModal('dateModalVisible'); }}>{byDateLabel}</ListItem>
          <ListItem onClick={() => { this._toggleFilterModal('dateModalVisible'); }}>{this._getDateFilterLabel()}</ListItem>
          {/* <ListItem onClick={() => { this._toggleFilterModal('manifestModalVisible'); }}>{this._getManifestFilterLabel()}</ListItem> */}
          {customerFilter && <ListItem onClick={() => { this._toggleFilterModal('customerModalVisible'); }}>{this._getCustomerFilterLabel()}</ListItem>}
          {shippingGroupFilter && <ListItem onClick={() => { this._toggleFilterModal('shippingGroupModalVisible'); }}>{this._getShippingGroupFilterLabel()}</ListItem>}
        </List>

        {
          dateModalVisible &&
          <RetrofitDateModal
            initialPeriod={initialPeriod}
            finalPeriod={finalPeriod}
            byDate={byDate}
            onApply={this._applyDateFilter}
            onBackdropClick={() => { this._toggleFilterModal('dateModalVisible'); }}
          />
        }
        {
          customerFilter && customerModalVisible &&
          <CustomerModal
            minimumDigits={customerMinimumDigits}
            selectedCustomers={selectedCustomers}
            isOnlyKeyAccounts={isOnlyKeyAccounts}
            onApply={this._applyCustomerFilter}
            onBackdropClick={() => { this._toggleFilterModal('customerModalVisible'); }}
          />
        }
        {
          shippingGroupFilter && shippingGroupModalVisible &&
          <ShippingGroupModal
            selectedShippingGroup={shippingGroupId}
            onApply={this._applyShippingGroupFilter}
            onBackdropClick={() => { this._toggleFilterModal('shippingGroupModalVisible'); }}
          />
        }
        {
          shippingCompanyModalVisible &&
          <ShippingCompanyModal
            selectedShippingCompanies={selectedShippingCompanies}
            onApply={this._applyShippingGroupFilter}
            onBackdropClick={() => { this._toggleFilterModal('shippingCompanyModalVisible'); }}
          />
        }
        {
          regionModalVisible &&
          <RegionModal
            selectedRegions={selectedRegions}
            selectedUfs={selectedUfs}
            onApply={this._applyRegionFilter}
            onBackdropClick={() => { this._toggleFilterModal('regionModalVisible'); }}
          />
        }
        {
          manifestModalVisible &&
          <ManifestModal
            manifestType={manifestType}
            onChangeValue={this._applyManifestFilter}
            onBackdropClick={() => { this._toggleFilterModal('manifestModalVisible'); }}
          />
        }
      </Panel>
    );
  }
}

// redux

const mapStateToProps = state => (
  {
    initialPeriod: state.dashboardFilters.filters.initialPeriod,
    finalPeriod: state.dashboardFilters.filters.finalPeriod,
    byDate: state.dashboardFilters.filters.byDate,
    selectedShippingCompanies: state.dashboardFilters.filters.listCompany,
    shippingGroupId: state.dashboardFilters.filters.shippingGroupId,
    selectedCustomers: state.dashboardFilters.filters.listCustomers,
    isOnlyKeyAccounts: state.dashboardFilters.filters.keyAccount,
    selectedRegions: state.dashboardFilters.filters.listRegion,
    selectedUfs: state.dashboardFilters.filters.listUf,
    manifestType: state.dashboardFilters.filters.manifestType,
    shippingGroupsList: state.shippingGroup.list,
  });

export default connect(mapStateToProps)(DashboardFilter);
